import React from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';
import {noop} from 'lodash';

import {
  Code,
  FlexView,
  Footprint,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {rose} from '/theme/color/secondary.color';

import ModalHeader from '../ModalHeader';

const storyStyle = StyleSheet.create({
  footprint: {
    width: '100%',
  },
  content: {
    width: '100%',
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: rose,
  },
});

storiesOf('layout', module).add('ModalHeader', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView expand={true}>
        <Heading level={1}>Modal Header</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>ModalHeader</Code> component is used to render a modal
          header with title and actions.
        </Text>
        <Spacer size={16} />
        <Text>
          The space above the icons is reserved for the device's status bar. The
          actual amount of whitespace will be different between different device
          screen geometries.
        </Text>
        <Spacer size={16} />
        <Footprint style={storyStyle.footprint}>
          <ModalHeader
            // @ts-expect-error TS(2769): No overload matches this call.
            title="Modal Title"
            onClose={noop}
            actionLabel="Do This"
            onActionPress={noop}
          />
        </Footprint>
        <Spacer size={16} />
        <Heading level={2}>Content Wrapper</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>ModalHeader</Code> wrapper component is a wrapper component
          around some contents.
        </Text>
        <Spacer size={16} />
        <Footprint style={storyStyle.footprint}>
          <ModalHeader
            title="Modal Title"
            onClose={noop}
            actionLabel="Do This"
            onActionPress={noop}>
            <View style={storyStyle.content}>
              <Text>Content</Text>
            </View>
          </ModalHeader>
        </Footprint>
        <Spacer size={6} />
        <Code>{'<ModalHeader>'}</Code>
        <Code>{'  title="Modal Title"'}</Code>
        <Code>{'  onClose={...}'}</Code>
        <Code>{'  actionLabel="Do This"'}</Code>
        <Code>{'  onActionPress={...}'}</Code>

        <Code>{'>'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'</ModalHeader>'}</Code>
        <Spacer size={16} />
        <Heading level={2}>Optional Props</Heading>
        <Spacer size={16} />
        <Text>
          If the <Code>title</Code> props is missing, then a title will not be
          rendered.
        </Text>
        <Spacer size={16} />
        <Text>
          If the <Code>onClose</Code> props is missing, then a close button will
          not be rendered.
        </Text>
        <Spacer size={16} />
        <Text>
          If the <Code>actionLabel</Code> props is missing or if the{' '}
          <Code>onActionPress</Code> props is not a function, then action button
          will not be rendered.
        </Text>
      </FlexView>
    </Spacing>
  </ScrollView>
));
